import type { IPaymentScheduleInfoModel, IPaymentScheduleInfoNumericInputModel } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

export default (paymentScheduleInfo: IPaymentScheduleInfoNumericInputModel): IPaymentScheduleInfoModel => {
  const { firstAvailableEndDate } = paymentScheduleInfo;
  return {
    firstAvailableEndDate:
      typeof firstAvailableEndDate === 'string'
        ? firstAvailableEndDate
        : formatTimestampToYMDString(firstAvailableEndDate),
  };
};
